import React from 'react';

import { Form } from 'antd';

import { MessageType } from './_hooks';
import { TextAreaEmojiPicker } from '@common/components';

export const NoteTextArea = ({
  selectedMessageType,
  createLoading,
  setMessage,
  message,
}: {
  selectedMessageType: MessageType | undefined;
  createLoading: boolean;
  setMessage: (message: string) => void;
  message: string;
}) => {
  const isRequired = ['home_unit', 'workforce_groups'].some(
    (messageType) => messageType === selectedMessageType
  );

  return (
    <Form.Item
      label="Note"
      name="note"
      rules={[
        {
          max: 150,
          message: 'Note must be fewer than 150 characters',
        },
      ]}
      required={isRequired}
    >
      <TextAreaEmojiPicker
        rows={4}
        disabled={createLoading}
        onChange={setMessage}
        value={message}
        maxLength={150}
        placeholder="Add details to increase the chance of this shift being claimed."
      />
    </Form.Item>
  );
};
